import { Component } from '@angular/core';
import { MailFormComponent } from './mail-form/mail-form.component';
import { MailSendResultComponent } from './mail-send-result/mail-send-result.component';
import { RouterModule } from '@angular/router';
import { TemplateTop5Component } from '../templates/template-top5/template-top5.component';

@Component({
  selector: 'fnsr-mail',
  standalone: true,
  imports: [MailFormComponent, MailSendResultComponent, RouterModule, TemplateTop5Component],
  templateUrl: './mail.component.html'
})
export class MailComponent {
}
